/**
 *
 * File: SharedLayout.js
 *
 * Purpose: DrivePartner passenger app shared layout page.
 *
 * Author:   Thomas Burgard (Software development)
 * Created:  18.04.2023
 * Modified: 18.04.2023
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import React from "react";
import { Outlet } from "react-router-dom";
import HeaderProtectedArea from "../../components/header/HeaderProtectedArea";
import Footer from "../../components/footer/Footer";

/**
 *  Component: SharedLayout
 *
 *  Purpose: DrivePartner passenger app shared layout with menu bar.
 *
 * @param {*} props
 * @returns JSX-Code
 */
const SharedLayout = (props) => {   
  const userData = props.userData;




  //----------------------------------
  // Return JSX-Code
  //----------------------------------
  return (
    <>
      <HeaderProtectedArea
        userData={userData}
        style={{ left: "0", right: "0" }}
      />
      <Outlet />
      <Footer userData={userData} />
    </>
  );
};

export default SharedLayout;
